import { Target } from '../types';

/**
 * Utility functions for Sales feature
 */

export const targetToLabel = (t: Target): string => {
  // If name exists, use it; otherwise construct from available fields
  if (t.name) {
    return t.name;
  }
  const parts: string[] = [];
  if (t.role) parts.push(t.role);
  if (t.industry) parts.push(t.industry);
  if (t.country) parts.push(t.country);
  if (t.language) parts.push(t.language);
  return parts.length > 0 ? parts.join(' – ') : 'Unnamed Target';
};

// Export status helpers
export * from './statusHelpers';

